import { createSelector } from '@ngrx/store';
import { NydusRecipient } from '@rd/types/nydus-recipient.type';
import { Order } from '@rd/types/order.type';
import { CurrentOrderState } from '../reducers/current-order.reducer';
import { getOrderCheckoutState, OrderCheckoutState } from '../reducers/index';

const getCurrentOrderState = createSelector(
  getOrderCheckoutState,
  (state: OrderCheckoutState) => state.currentOrder,
);

export const getCurrentOrder = createSelector(
  getCurrentOrderState,
  (state: CurrentOrderState): Order | null => state.currentOrder,
);

// We return a NullRecipient for type-safety when prefilling
// Note: This means that this selector can't be boolean checked
export const getCurrentOrderDeliveryDetails = createSelector(
  getCurrentOrder,
  (state: Order | null): NydusRecipient => {
    const NullRecipient: NydusRecipient = {
      address: null,
      companyName: null,
      firstName: '',
      lastName: '',
      phoneNumber: '',
      email: '',
    };

    if (state === null || !state.data.recipient) {
      return NullRecipient;
    }

    return state.data.recipient;
  },
);

export const getCurrentOrderError = createSelector(
  getCurrentOrderState,
  (state: CurrentOrderState) => state.error,
);

export const getCurrentOrderLoading = createSelector(
  getCurrentOrderState,
  (state: CurrentOrderState) => state.loading,
);
